import React from 'react';

function BookmarkViewIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testId="My-Bookmarks"
    >
      <path
        d="M18.75 19.25V3.8C18.75 3.73333 18.7167 3.66667 18.65 3.6C18.5833 3.53333 18.5167 3.5 18.45 3.5H6.75V2H18.45C18.95 2 19.375 2.175 19.725 2.525C20.075 2.875 20.25 3.3 20.25 3.8V19.25H18.75ZM5.25 19.95L10.25 17.8L15.25 19.95V7.3C15.25 7.23333 15.2167 7.16667 15.15 7.1C15.0833 7.03333 15.0167 7 14.95 7H5.55C5.48333 7 5.41667 7.03333 5.35 7.1C5.28333 7.16667 5.25 7.23333 5.25 7.3V19.95ZM3.75 22.25V7.3C3.75 6.8 3.925 6.375 4.275 6.025C4.625 5.675 5.05 5.5 5.55 5.5H14.95C15.45 5.5 15.875 5.675 16.225 6.025C16.575 6.375 16.75 6.8 16.75 7.3V22.25L10.25 19.45L3.75 22.25ZM5.25 7C5.25 7 5.28333 7 5.35 7C5.41667 7 5.48333 7 5.55 7H14.95C15.0167 7 15.0833 7 15.15 7C15.2167 7 15.25 7 15.25 7H10.25H5.25Z"
        fill="#303641"
      />
    </svg>
  );
}

export default BookmarkViewIcon;
